import { render } from "./ParadigmValues.vue?vue&type=template&id=c9410326&scoped=true&ts=true"
import script from "./ParadigmValues.vue?vue&type=script&lang=ts"
export * from "./ParadigmValues.vue?vue&type=script&lang=ts"

import "./ParadigmValues.vue?vue&type=style&index=0&id=c9410326&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9410326"]])

export default __exports__